import axios from 'axios'

const state = {
  companyId: '',
  lists: [],
  filter: {},
  sort: {},
  total: 0,
  page: 1,
  perPage: 10,
  loaded: false,
}

const getters = {}

const mutations = {
  SET_COMPANY_ID(state, companyId) {
    state.companyId = companyId
  },
  SET_STATE_LOADED(state, flag) {
    state.loaded = flag
  },
  SET_LISTS_TOTAL(state, total) {
    state.total = total
  },
  SET_LISTS(state, data) {
    state.lists = data
  },
  SET_PAGE(state, { page, perPage }) {
    state.page = page
    state.perPage = perPage
  },
  SET_FILTER_PARAMS(state, params) {
    state.filter = { ...params }
  },
  SET_SORT_PARAMS(state, params) {
    state.sort = { ...params }
  },
  NEW_ITEM(state, item) {
    state.lists.concat(item)
    state.total = state.total++
  },
  UPDATE_ITEM(state, newItem) {
    state.lists.forEach((element, index) => {
      if (element.id === newItem.id) {
        state.lists[index] = newItem
      }
    })
  },
}

const actions = {
  setCompanyId,
  fetchLists,
  setPage,
  setFilterParams,
  setSortParams,
  deleteItem,
  newItem,
  updateItem,
  searchGroupsOfCompany,
  getCauses,
  searchOrganization,
  fetchGroupsHierarchy,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function setCompanyId({ commit, state, rootState }, { companyId }) {
  commit('SET_COMPANY_ID', companyId)
}

function setPage({ commit, state, rootState }, { page, perPage }) {
  commit('SET_PAGE', { page, perPage })
  return fetchLists(
    { commit, state, rootState },
    { companyId: state.companyId }
  )
}

function setFilterParams({ commit, state, rootState }, params) {
  commit('SET_FILTER_PARAMS', params)
  return fetchLists(
    { commit, state, rootState },
    { companyId: state.companyId }
  )
}

function setSortParams({ commit, state, rootState }, params) {
  commit('SET_SORT_PARAMS', params)
  return fetchLists(
    { commit, state, rootState },
    { companyId: state.companyId }
  )
}

function fetchLists({ commit, state, rootState }, requestParams) {
  // Refresh the table
  const { companyId } = requestParams
  const { filter, page, perPage, sort } = state
  const curCompanyId = state.companyId
  let params = {}
  if (curCompanyId === companyId) {
    commit('SET_LISTS', null)
    commit('SET_STATE_LOADED', false)
    params = {
      companyId,
      filter,
      sort,
      page,
      per_page: perPage,
    }
  } else {
    params = requestParams
  }
  // Fetch the groups from the API
  return axios
    .get('/api/v1/group', { params })
    .then((response) => {
      const { data, total } = response.data
      // save the lists in Vuex store
      if (curCompanyId === companyId) {
        commit('SET_LISTS', data)
        commit('SET_LISTS_TOTAL', total)
      }
      return response.data
    })
    .finally(() => {
      if (curCompanyId === companyId) {
        commit('SET_STATE_LOADED', true)
      }
    })
}

function deleteItem({ commit, state, rootState }, { companyId, groupId }) {
  const curCompanyId = state.companyId
  return axios.delete(`/api/v1/group/${groupId}`).then((response) => {
    if (response.data && curCompanyId === companyId) {
      // Refresh the lists
      return fetchLists({ commit, state, rootState }, { companyId })
    }
    return response.data
  })
}

function newItem({ commit, state, rootState }, { companyId, params }) {
  const curCompanyId = state.companyId
  return axios.post(`/api/v1/group`, params).then((response) => {
    // add item in store
    if (curCompanyId === companyId) {
      commit('NEW_ITEM', response.data)
    }
    return response.data
  })
}

function updateItem({ commit, state, rootState }, params) {
  // save the item info
  return axios.post(`/api/v1/group/${params.id}`, params).then((response) => {
    // save the item in store
    commit('UPDATE_ITEM', response.data)
    return response.data
  })
}

// search users in a company
function searchGroupsOfCompany({ commit, state, rootState }, { groupTag }) {
  return axios
    .get(`/api/v1/group/startingWith/${groupTag}`)
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}

// add search users to a group
function getCauses({ commit, state, rootState }) {
  return axios.get(`/api/v1/causes`).then((response) => {
    return response.data
  })
}

// search users in a company
function searchOrganization({ commit, state, rootState }, { orgTag }) {
  return axios
    .get(`/api/v1/charity-organization/startingWith/${orgTag}`)
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}

function fetchGroupsHierarchy({ commit, state, rootState }, { companyId }) {
  return axios
    .get(`/api/v1/company/${companyId}/groupsHierarchy`)
    .then((response) => {
      return response.data
    })
}
